import { Constants } from "../constants/Contants";
import request from "../utils/useApi";
export const addnewArticle = async (data) => {
  try {
    const res = await request.post(Constants.add_article_api_url, data);
    if (res) {
      return res;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
export const getArticles = async () => {
  try {
    const res = await request.get(Constants.get_article_api_url);
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const deleteArticles = async (id) => {
  try {
    const res = await request.delete(
      `${Constants.delete_article_api_url}/${id}`
    );
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const getSpecificArticle = async (id) => {
  try {
    const res = await request.get(
      `${Constants.get_specific_article_api_url}/${id}`
    );
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const editArticle = async (data, id) => {
  try {
    const res = await request.put(
      `${Constants.edit_article_api_url}/${id}`,
      data
    );
    if (res) {
      return res;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
